var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrButton',_vm._b({on:{"nv-enter":function($event){return _vm.$emit('nv-enter', $event)}}},'PrButton',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }